import { ICON_NAME } from '@app/constants/icon'

import { abnormalTypeEnum } from './enums'

import type { AbnormalType } from './types'
import type { IconNameType } from '@app/types/icon'

export const mapAbnormalTypeToIconName = (abnormalType: AbnormalType | null): IconNameType | null => {
  switch (abnormalType) {
    case abnormalTypeEnum.ABNORMAL_PRICE:
    case abnormalTypeEnum.SUPER_ABNORMAL_PRICE:
      return ICON_NAME.priceTag
    case abnormalTypeEnum.PRICE_TRANSFERRED:
      return ICON_NAME.priceChange
    case abnormalTypeEnum.INCORRECT_VOLUME:
    case abnormalTypeEnum.RECALCULATED:
      return ICON_NAME.weight
    case abnormalTypeEnum.PRICE_RESTORED:
    case abnormalTypeEnum.PRICE_TRANSLATED:
      return ICON_NAME.broadcasting
    default:
      return null
  }
}
